import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "project-template-subnav" }
const _hoisted_2 = { class: "headline" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_icon = _resolveComponent("arrow-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "decoration-none",
        to: "/settings/project-templates"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_arrow_icon, { id: "arrow-back" }),
          _createTextVNode(" Back to project templates")
        ]),
        _: 1
      }),
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.name), 1)
    ]),
    _hoisted_4,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (link) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        key: link.label,
        to: link.to,
        class: "link"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(link.label), 1)
        ]),
        _: 2
      }, 1032, ["to"]))
    }), 128))
  ]))
}